import { SET_CURRENT_MODAL } from "@/store/mutation-types";

export default {
  [SET_CURRENT_MODAL](state, modal) {
    const { name = "", data = null } = modal || {};

    state.name = name;
    state.data = data;
  }
};
